export enum ServiceAgreementStatus {
    open,
    cancelled,
    suspended,
    unsuspended,
    expired
}